import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../../utils/url-utils';
import { errorHandl } from '../../../utils/network-utils';
import { getImageAsEmbedNew, removeNonAllowedCharactersFromPDF, urlToArrayBuffer } from '../../../utils/utils.common';
import * as moment from "moment-timezone";



@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient) { }


  async getDriverGrivenceReport(payload, user) {

    const response = await fetch('assets/documents/driver-grievance-report.pdf');
    let pdfBuffer = await response.arrayBuffer();

    pdfBuffer = await this.fillPDF(pdfBuffer, payload, user);

    if (pdfBuffer) {
      const blob = new Blob([pdfBuffer], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'driver-grievance-report.pdf'
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }


  async fillPDF(pdfBuffer: ArrayBuffer, payload, user): Promise<ArrayBuffer> {
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();
    const profileLogo: any = await urlToArrayBuffer(user.profileImageURL);
    const companyLogo = await getImageAsEmbedNew(pdfDoc, user.profileImageURL, profileLogo);
    //Reporting Details
    form.getTextField('company_name').setText(payload.createdBy.toString());
    if (companyLogo)
      form.getTextField('company_logo').setImage(companyLogo);
    form.getTextField('dos').setText(moment(payload.appointmentTime).format('MM/DD/YY HH:mm') || ''.toString());
    form.getTextField('reporting_time').setText('Reporting time');
    form.getTextField('complaint_id').setText("Client Id");
    form.getTextField('reported_driver').setText(payload.driver.displayName.toString());
    // //temp address on incident_address
    form.getTextField('incident_address').setText(payload.jobOriginAddress.toString());
    // //Member
    form.getTextField('member_name').setText(payload.priorityClient.displayName.toString());
    form.getTextField('member_cellphone').setText(payload.priorityClient.cellPhone.toString());
    form.getTextField('member_contactNo').setText(payload.priorityClient.contactNumber.toString());
    form.getTextField('client_id').setText(payload.memberId.toString());
    form.getTextField('member_weight').setText("Weight Missing");
    form.getTextField('member_gender').setText('Male');
    form.getTextField('insurance_id').setText(payload.priorityClient.clientId.toString());
    form.getTextField('member_dob').setText(payload.dob.toString());
    form.getTextField('member_escort').setText(payload.noOfEscorts ? payload.noOfEscorts.toString() : '');
    // //Trip Infomation
    form.getTextField('pu_address').setText(payload.jobOriginAddress.toString());
    form.getTextField('do_address').setText(payload.jobDestinationAddress.toString());
    form.getTextField('trip_status').setText(payload.status.toString());
    form.getTextField('trip_notes').setText(payload.companyNote.slice(0, 50));
    form.getTextField('trip_miles').setText(payload.milage.toString());
    form.getTextField('pu_time').setText(moment(payload.scheduleTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('do_time').setText(moment(payload.appointmentTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('act_pu_time').setText(moment(payload.scheduleTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('act_do_time').setText(moment(payload.appointmentTime).format('MM/DD/YY HH:mm') || '');
    form.getTextField('cancel_reason').setText(payload.changeReason.toString());
    form.getTextField('broker_name').setText(payload.payor.toString());
    form.getTextField('trip_id').setText(payload.tripId.toString());
    form.getTextField('los').setText(payload.tripRequirement.toString());
    // // Vin missing
    form.getTextField('vin').setText('0');

    // //timestamps
    form.getTextField('accepted_time').setText('0');
    form.getTextField('onscene_time').setText(moment(payload.job.trackInfoJob.jobArrived.time).format('MM/DD/YY HH:mm') || '');
    form.getTextField('started_time').setText(moment(payload.job.trackInfoJob.jobStarted.time).format('MM/DD/YY HH:mm') || '');
    form.getTextField('ended_time').setText(moment(payload.job.trackInfoJob.jobFinished.time).format('MM/DD/YY HH:mm') || '');
    form.getTextField('accepted_coordinate').setText("Coordinates Missing");
    form.getTextField('onscene_coordinate').setText(`${payload.job.trackInfoJob.jobArrived.coords[0]} - ${payload.job.trackInfoJob.jobArrived.coords[1]}`);
    form.getTextField('started_coordinate').setText(`${payload.job.trackInfoJob.jobStarted.coords[0]} - ${payload.job.trackInfoJob.jobStarted.coords[1]}`);
    form.getTextField('ended_coordinate').setText(`${payload.job.trackInfoJob.jobFinished.coords[0]} - ${payload.job.trackInfoJob.jobFinished.coords[1]}`);

    form.getTextField('driver_grievance').setText(payload.driverNote.toString());
    form.getTextField('driver_signature').setText(payload.signatureImage || "N/A");


    // form.getTextField('provider_company').setText('test');
    // remove non ASCII
    await removeNonAllowedCharactersFromPDF(form);
    const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
    return modifiedBuffer;


  }




  getReportsWithNgrx(data): Observable<any> {
    const userId = data._id;
    delete data._id;
    return this.http.put<any>(urls.BASE_URL + urls.GET_REPORTS_URL + `${userId}`, data)
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriverPdfReport(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('check', data.mailCheck);
    params = params.append('endDate', data.endDate);
    params = params.append('startDate', data.startDate);

    return this.http.get<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_DRIVER_PDF_REPORT_URL + `${data.driverId}?`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getPaymentPdfReport(data): Observable<any> {
    let params = new HttpParams();
    params = params.append('endDate', data.endDate);
    params = params.append('startDate', data.startDate);

    return this.http.get<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_PAYMENT_PDF_REPORT_URL + `${data.id}?`, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  getDriversScore(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_KPI_SCORE, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  addEdiReport(file: File): Observable<any> {
    const formData = new FormData();
    if (file) {
      formData.append('ediFile', file, file.name);
    }
    return this.http.post<any>(urls.BASE_URL + urls.EDIREPORTS, formData)
      .pipe(
        catchError(errorHandl)
      );
  }

  getEdiReport(): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.EDIREPORTS)
      .pipe(
        catchError(errorHandl)
      );
  }
  getEdiReportbyId(id): Observable<any> {
    return this.http.get<any>(urls.BASE_URL + urls.EDIREPORTS + "/" + id)
      .pipe(
        catchError(errorHandl)
      );
  }
  getEdiReportCSV(id): Observable<any> {
    return this.http.get<any>(urls.BASE_REPORT_SERVER_URL + urls.EDIREPORTS + "/" + id)
      .pipe(
        catchError(errorHandl)
      );

  }




  getOutBoundMessages(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.OUTBOUND_MESSAGES, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  async getCoTripReport(payload, company, date, loader, fleet) {
    const pdfArray = [];
    let newtemp = []
    const arrayOfkeys = Object.keys(payload);
    for (const [index, key] of arrayOfkeys.entries()) {
      newtemp.push(payload[key])
      if (index === 2) {
        const response = await fetch("assets/documents/co-trip-report.pdf");
        let pdfBuffer = await response.arrayBuffer();
        pdfBuffer = await this.fillCoTripReport(pdfBuffer, newtemp, company, date, fleet);
        pdfArray.push(pdfBuffer);
        newtemp = [];
      } else if (index > 2 && (index - 2) % 2 === 0) {
        const response = await fetch("assets/documents/co-trip-report-blank.pdf");
        let pdfBuffer = await response.arrayBuffer();
        pdfBuffer = await this.fillCoTripReport(pdfBuffer, newtemp, company, date, fleet);
        pdfArray.push(pdfBuffer);
        newtemp = [];
      }
    }

    if (!pdfArray.length && newtemp.length) {
      const response = await fetch("assets/documents/co-trip-report.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillCoTripReport(pdfBuffer, newtemp, company, date, fleet);
      pdfArray.push(pdfBuffer);
      newtemp = [];
    } else if (pdfArray.length && newtemp.length) {
      const response = await fetch("assets/documents/co-trip-report-blank.pdf");
      let pdfBuffer = await response.arrayBuffer();
      pdfBuffer = await this.fillCoTripReport(pdfBuffer, newtemp, company, date, fleet);
      pdfArray.push(pdfBuffer);

    }

    const pdfDoc = await PDFDocument.create();
    for (const pdfBytesData of pdfArray) {
      const sourcePDF = await PDFDocument.load(pdfBytesData);
      const [page] = await pdfDoc.copyPages(sourcePDF, [0]);
      pdfDoc.addPage(page);
    }
    const mergedPdfBytes = await pdfDoc.save();
    if (mergedPdfBytes) {
      const currentDate = moment().format("MM-DD-YYYY");
      const fileName = `co_trip_report_${currentDate}.pdf`;
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      loader.isLoading = false;
      window.URL.revokeObjectURL(url);
    }
  }

  async fillCoTripReport(pdfBuffer: ArrayBuffer, trips, user, date, fleet): Promise<ArrayBuffer> {
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();


    const company = user.company ? user.company : user;
    const lastIndex = (trips.length) - 1
    const lastTrip = trips[lastIndex]
    const weekendDate = moment(lastTrip.scheduleTime).tz(company.timeZone).endOf('week').format("MM/DD/YYYY")

    if (trips.length >= 2) {
      form.getRadioGroup("Group5").select('Choice2');
    }
    else {
      form.getRadioGroup("Group5").select('Choice1');
    }
    if (company) {
      form.getTextField("company_name").setText(company.displayName);
      form.getTextField("npi").setText(company.npi);

    }
    if (date) {
      form.getTextField("date").setText(moment(date).tz(company.timeZone).format('MM/DD/YYYY'));
    }
    if (trips) {
      form.getTextField("facility_name").setText(trips[0].jobDestinationAddress);
      form.getTextField("pu_mon").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('MM'));
      form.getTextField("pu_day").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('DD'));
      form.getTextField("pu_year").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('yyyy'));
      form.getTextField("pu_hour").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('hh'));
      form.getTextField("pu_min").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('mm'));


    }
    for (const [index, trip] of trips.entries()) {
      if (fleet && trip.fleet && fleet[trip.fleet] && fleet[trip.fleet].losDetails && fleet[trip.fleet].losDetails.title) {
        if ((fleet[trip.fleet].losDetails.title).toUpperCase() === ('Ambulatory').toUpperCase()) {
          form.getRadioGroup("Group4").select('Choice1');
        } else if ((fleet[trip.fleet].losDetails.title).toUpperCase() === ('Stretcher').toUpperCase()) {
          form.getRadioGroup("Group4").select('Choice4');
        }
        else if ((fleet[trip.fleet].losDetails.title).toUpperCase() === ('Wheelchair').toUpperCase()) {
          form.getRadioGroup("Group4").select('Choice3');
        }
        else {
          form.getRadioGroup("Group4").select('Choice7');
        }
      }


      if (trip) {
        if (trip.priorityClient) {
          form.getTextField("member_name").setText(trip.priorityClient.displayName);
          form.getTextField("medicaid_id").setText(trip.priorityClient.clientId);
          form.getTextField("representative_name").setText(trip.priorityClient.displayName);
        }
        if (trip.driver) {
          form.getTextField("driver_name").setText(trip.driver.displayName);
          form.getTextField("Vin").setText(fleet[trip.fleet].vin);
          form.getTextField("facility_representative_title").setText('Patient');

        }

        form.getTextField("pickup_time" + index).setText(moment(trip.scheduleTime).tz(company.timeZone).format('hh:mm'));
        form.getTextField("dropoff_time" + index).setText(moment(trip.scheduleTime).tz(company.timeZone).format('hh:mm'));



        const dayTime = moment(trip.scheduleTime).tz(company.timeZone).format('A');
        if (dayTime === 'AM') {
          form.getRadioGroup("Group1").select('Choice1');
        } else {
          form.getRadioGroup("Group1").select('Choice2');
        }
        form.getRadioGroup("Group2").select('Choice1');
        form.getRadioGroup("Group3").select('Choice2');


        const brokenPuAddress = this.parseAddress(trip.jobOriginAddress)
        form.getTextField("pu_address" + index).setText(brokenPuAddress.street);
        form.getTextField("city" + index).setText(brokenPuAddress.city);
        form.getTextField("state" + index).setText(brokenPuAddress.state);
        form.getTextField("zip" + index).setText(brokenPuAddress.zip);

        const brokenDoAddress = this.parseAddress(trip.jobDestinationAddress)
        form.getTextField("do_address" + index).setText(brokenDoAddress.street);
        form.getTextField("city" + index).setText(brokenDoAddress.city);
        form.getTextField("state" + index).setText(brokenDoAddress.state);
        form.getTextField("zip" + index).setText(brokenDoAddress.zip);
        if (trip.scheduleTime) {
          const dayTime = moment(trip.scheduleTime).tz(company.timeZone).format('A');
          if (dayTime === 'AM') {
            form.getRadioGroup("pu_group" + index).select('Choice1');
          } else {
            form.getRadioGroup("pu_group" + index).select('Choice2');
          }
        }
        if (trip.appointmentTime) {
          const dayTime = moment(trip.appointmentTime).tz(company.timeZone).format('A');
          if (dayTime === 'AM') {
            form.getRadioGroup("do_group" + index).select('Choice1');
          } else {
            form.getRadioGroup("do_group" + index).select('Choice2');
          }
        }
        form.getTextField("miles" + index).setText(trip.milage + '');

        if (trip.job) {
          form.getTextField("pu_odometer" + index).setText(trip.odometerStart + '');
          form.getTextField("do_odometer" + index).setText(trip.odometerStop + '');

          if (trip.signatureImage) {
            const profileLogo: any = await urlToArrayBuffer(trip.signatureImage);
            const memberSignature = await getImageAsEmbedNew(pdfDoc, trip.signatureImage, profileLogo);
            form.getTextField("member_signature").setImage(memberSignature);
          }

        }


      }

    }

    // remove non ASCII
    await removeNonAllowedCharactersFromPDF(form);
    const modifiedBuffer = await pdfDoc.save(); // Save the modified PDF back to a buffer
    return modifiedBuffer;
  }

  // ---Colorado Trip Log Report--
async getColoradoTripLog(trips, company, date, loader, fleet, preLos,preSpaceType) {
  const pdfBuffers: ArrayBuffer[] = [];

  const groupByMember = trips.reduce((acc, trip) => {
    const memberId = trip.client ? trip.client : 'unknown';
    if (!acc[memberId]) {
      acc[memberId] = [];
    }
    acc[memberId].push(trip);
    return acc;
  }, {});
  for (const memberId in groupByMember) {
    const memberTrips = groupByMember[memberId];
    if (memberTrips.length === 0) continue;

    for (let i = 0; i < memberTrips.length; i += 2) {
      const chunk = memberTrips.slice(i, i + 2);

      const template = i === 0
        ? "assets/documents/c-trip-log.pdf"
        : "assets/documents/c-trip-log-blank.pdf";

      const response = await fetch(template);
      const pdfBuffer = await response.arrayBuffer();

      const filledBuffer = await this.fillSingleTripLog(pdfBuffer, chunk, company, date, fleet, preLos, preSpaceType);
      pdfBuffers.push(filledBuffer);
    }
  }

  // Merge all PDF pages
  const mergedDoc = await PDFDocument.create();

  for (const buffer of pdfBuffers) {
    const pdf = await PDFDocument.load(buffer);
    const [page] = await mergedDoc.copyPages(pdf, [0]);
    mergedDoc.addPage(page);
  }

  const finalBytes = await mergedDoc.save();

  const currentDate = moment().format("MM-DD-YYYY");
  const fileName = `c_trip_log_${currentDate}.pdf`;
  const blob = new Blob([finalBytes], { type: "application/pdf" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
  loader.loader = false;
  window.URL.revokeObjectURL(url);
}

  async fillSingleTripLog(pdfBuffer: ArrayBuffer, trips, user, date, fleet,preLos, preSpaceType): Promise<ArrayBuffer> {
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();
    const company = user.company ? user.company : user;

    form.getTextField("Members Name").setText(trips[0].priorityClient.displayName || 'N/A');
    form.getTextField("Member Health First Colorado ID").setText(trips[0].priorityClient.clientId || 'N/A');

    if(trips[0].additionalInfoJob)
    form.getTextField("escort name").setText(trips[0].additionalInfoJob.name || 'N/A');

    try {
      if (trips[0].signatureImage) {
        const profileLogo: any = await urlToArrayBuffer(trips[0].signatureImage);
        const memberSignature = await getImageAsEmbedNew(pdfDoc, trips[0].signatureImage, profileLogo);
        form.getTextField("Members Signature").setImage(memberSignature);
      }
    } catch (error) {
      console.error("Error setting member signature:", error);
    }
    // form.getTextField("Members Signature").setText(t.signatureImage);
    form.getTextField("Trip Date").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('MM/DD/YYYY'));
    form.getTextField("Drivers Name").setText(trips[0].driver.displayName || 'N/A');
    form.getTextField("Vehicle License Plate or VIN").setText(fleet[trips[0].fleet].driverCarNumber || 'N/A');
    form.getTextField("Date").setText(moment(trips[0].scheduleTime).tz(company.timeZone).format('MM/DD/YYYY'))
    // checkbox
    form.getRadioGroup("driver verify member identity").select("yes");
    if (preSpaceType && preSpaceType[trips[0].spaceType] && preSpaceType[trips[0].spaceType].title.toLowerCase().includes("wheelchair")) {
      form.getRadioGroup("type of vehicle").select("wheelchair van");
    } else if (preSpaceType && preSpaceType[trips[0].spaceType] && preSpaceType[trips[0].spaceType].title.toLowerCase().includes("stretcher")) {
      form.getRadioGroup("type of vehicle").select("stretcher van");
    } else {
      form.getRadioGroup("type of vehicle").select("Mobility/Ambulatory vehicle");
    }

    if (trips[0] && trips[0].trackInfoJob && trips[0].trackInfoJob.jobArrived.time) {
      form.getTextField("Pickup TIme").setText(moment(trips[0].trackInfoJob.jobArrived.time).tz(company.timeZone).format('HH:mm'))
      form.getRadioGroup("pick up time").select(moment(trips[0].trackInfoJob.jobArrived.time).tz(company.timeZone).format('a'))
    }
    form.getTextField("Pickup Odometer Reading").setText(trips[0].odometerStart);
    form.getTextField("Pickup Street Address City State Zip").setText(trips[0].jobOriginAddress || 'N/A');
    if (trips[0] && trips[0].trackInfoJob && trips[0].trackInfoJob.jobCompleted.time) {
      form.getTextField("Actual DropOff Time  AM  PM").setText(moment(trips[0].trackInfoJob.jobCompleted.time).tz(company.timeZone).format('HH:mm'))
      form.getRadioGroup("dropoff time").select(moment(trips[0].trackInfoJob.jobCompleted.time).tz(company.timeZone).format('a'))
    }
    form.getTextField("Destination Odometer Reading").setText(trips[0].odometerStop);
    form.getTextField("Dropoff Destination Street Address City State Zip").setText(trips[0].jobDestinationAddress || 'N/A');
    // form.getRadioGroup("typeOfTrip_round").select('Yes');

    if (trips.length > 1) {
      form.getRadioGroup("type of trip").select('round trip');

       form.getTextField("Date_2").setText(moment(trips[1].scheduleTime).tz(company.timeZone).format('MM/DD/YYYY'))

      if (trips[1] && trips[1].trackInfoJob && trips[1].trackInfoJob.jobArrived.time) {
        form.getTextField("pickup time 2").setText(moment(trips[1].trackInfoJob.jobArrived.time).tz(company.timeZone).format('HH:mm'))
        form.getRadioGroup("second pickup time").select(moment(trips[1].trackInfoJob.jobArrived.time).tz(company.timeZone).format('a'))

      }
      form.getTextField("Pickup Odometer Reading_2").setText(trips[1].odometerStart);
      form.getTextField("Pickup Street Address City State Zip_2").setText(trips[1].jobOriginAddress || 'N/A');
      if (trips[1] && trips[1].trackInfoJob && trips[1].trackInfoJob.jobCompleted.time) {
        form.getTextField("Actual DropOff Time  AM  PM_2").setText(moment(trips[1].trackInfoJob.jobCompleted.time).tz(company.timeZone).format('HH:mm'))
        form.getRadioGroup("second dropoff time").select(moment(trips[1].trackInfoJob.jobCompleted.time).tz(company.timeZone).format('a'))
      }
      form.getTextField("Destination Odometer Reading_2").setText(trips[1].odometerStop);
      form.getTextField("Dropoff Destination Street Address City State Zip_2").setText(trips[1].jobDestinationAddress || 'N/A');

    } else {
       form.getRadioGroup("type of trip").select('one way');
    }

    await removeNonAllowedCharactersFromPDF(form);
    // form.flatten();
    return await pdfDoc.save();
  }



  parseAddress(address) {
    const regex = /(.*),\s*([^,]*),\s*([A-Z]{2})\s*(\d{5})?,/;
    const match = address.match(regex);

    if (!match)
      return {
        street: "",
        city: "",
        state: "",
        zip: "",
      };

    return {
      street: match[1] ? match[1].trim() : "",
      city: match[2] ? match[2].trim() : "",
      state: match[3] ? match[3].trim() : "",
      zip: match[4] ? match[4].trim() : "",
    };
  }



  // -----MBM Patient Report--

  async getMBMReport(payload, selectedMember) {

    const response = await fetch('assets/documents/mbm-report.pdf');
    let pdfBuffer = await response.arrayBuffer();

    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();

    form.getTextField('member_name').setText(selectedMember);
    form.getTextField('mrn').setText(payload.data[1][4]);

    if (payload.data[1][2] !== null) {
      form.getTextField('los').setText(payload.data[1][2]);
    } else {
      form.getTextField('los').setText('N/A');
    }

    payload.data.slice(3, -1).forEach((item, index) => {
      if (item && item.length >= 5) {

        form.getTextField(`dos_${index}`).setText(item[0].toString());
        form.getTextField(`pu_address_${index}`).setText(item[1]);
        form.getTextField(`do_address_${index}`).setText(item[2]);
        form.getTextField(`rates_${index}`).setText(item[3].replace(/\s+/g, ' '));
        form.getTextField(`total_trip_charges_${index}`).setText(item[4].toString());
      }
    });
    form.getTextField(`due_balance`).setText(payload.data[payload.data.length - 1][4]);
    const modifiedPdfBytes = await pdfDoc.save();
    // Trigger download
    const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mbm-report.pdf';
    a.click();
    window.URL.revokeObjectURL(url);
  }


  // ---MTM Driver Log ----
  async getMTMDriverLog(payload, user) {
    const response = await fetch('assets/documents/mtm-driver-log.pdf');
    const pdfBuffer = await response.arrayBuffer();
    const pdfDoc = await PDFDocument.load(pdfBuffer);
    const form = pdfDoc.getForm();

    form.getTextField('driver_name').setText(payload[0].driver.displayName);
    form.getTextField('driver_license').setText(payload[0].driver.driverLicenseNumber);
    form.getTextField('begin_odometer').setText(payload[0].odometerBegin.toString());
    form.getTextField('ending_odometer').setText(payload[0].odometerStop.toString());
    form.getTextField('total_daily_mileage').setText(payload[0].milage.toString());
    form.getTextField('dos').setText(moment(payload[0].scheduleTime).tz(user.timeZone).format('MM/DD/YYYY'));
    form.getTextField('submission_date').setText(moment().tz(user.timeZone).format('MM/DD/YYYY'));

    payload.forEach((trip, index) => {
      if (index > 10) return;
      if (trip.tripId) {
        let id = trip.tripId.slice(0, 5);
        form.getTextField(`TripLeg_${index}`).setText((id) || '');
      }

      form.getTextField(`AuthorizationNo_${index}`).setText(trip.authorizationNumber || '');
      form.getTextField(`AppointmentTime_${index}`).setText(moment(trip.appointmentTime).tz(user.timeZone).format('MM/DD/YYYY') || '');

      if (trip.priorityClient && trip.priorityClient.displayName) {
        form.getTextField(`Client'sFullname_${index}`).setText(trip.priorityClient.displayName);
      }
      form.getTextField(`Attendant'sFullname_${index}`).setText(trip.attendee ? trip.attendee : 'N/A');
      form.getTextField(`PickupAddress_${index}`).setText(trip.jobOriginAddress || '');
      form.getTextField(`Pickuptime_${index}`).setText(moment(trip.scheduleTime).tz(user.timeZone).format('MM/DD/YYYY') || '');
      form.getTextField(`Destinationaddress_${index}`).setText(trip.jobDestinationAddress || '');
      form.getTextField(`DropoffTime_${index}`).setText(moment(trip.appointmentTime).tz(user.timeZone).format('MM/DD/YYYY') || '');
      form.getTextField(`Client_${index}`).setText('');
      form.getTextField(`TripOutCome_${index}`).setText('');
      form.getTextField(`PAFonFile_${index}`).setText('');
      form.getTextField(`TotalMileageperleg_${index}`).setText(trip.milage.toString());
    });

    if (payload[0].signatureImage) {
      const logo: any = await urlToArrayBuffer(payload[0].signatureImage);
      const driverSignature = await getImageAsEmbedNew(pdfDoc, payload[0].signatureImage, logo);
      form.getTextField("driver_signature").setImage(driverSignature);
    }


    // Save modified PDF and trigger download
    const modifiedPdfBytes = await pdfDoc.save();
    const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mtm-driver-log.pdf';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getDriversEarnings(queryParams): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_REPORT_SERVER_URL + urls.GET_KPI_SCORE, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

}
